export default field => field.is_required;
